import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';

import {ApolloClient, InMemoryCache} from "../../_snowpack/pkg/@apollo/client.js";
export const createClient = () => new ApolloClient({
  uri: __SNOWPACK_ENV__.SNOWPACK_PUBLIC_GRAPHQL_URL,
  cache: new InMemoryCache()
});
